/** @format */

import template from './gb-edit-team-scoring-widget.html';

export const GbEditTeamScoringWidgetComponent = {
    template,
    require: {
        gbApp: '^^',
        gbEditTools: '^^',
    },
    bindings: {
        widget: '=',
    },
    controller: class GbEditTeamScoringWidgetComponent {
        constructor($gbEditTeamScoringDialog) {
            'ngInject';

            this.$gbEditTeamScoringDialog = $gbEditTeamScoringDialog;
        }

        editFilteredTables() {
            let data = {
                widget: this.widget,
                auction: this.gbApp.getAuctionUrl(),
            };

            return this.$gbEditTeamScoringDialog.show(data).then((hiddenUuids) => {
                this.widget.hidden_teams = hiddenUuids;
                this.gbEditTools.saveWidget();
            });
        }
    },
};
